export const getImagePaths = (imagePath?: string | null): string[] => {
  if (!imagePath) return []

  return imagePath
    .split(',')
    .map((path) => path.trim().replace(/\\/g, '/').replace('public', ''))
    .filter(Boolean)
}

export const getImagePath = (imagePath?: string | null, fallback = ''): string => {
  return getImagePaths(imagePath)[0] || fallback
}
